<template>
	<div class="withdraw-history-container">
		<div class="background-elements">
			<div class="wave wave-top"></div>
			<div class="wave wave-bottom"></div>
			<div class="circle circle-1"></div>
			<div class="circle circle-2"></div>
			<div class="circle circle-3"></div>
		</div>
		<div class="header-title">
			<van-icon name="arrow-left" class="back-icon" @click="$router.back()" /> 提现明细
		</div>
		<div class="content-wrapper">
			<div v-if="!listShow" role="feed" class="van-list">
				<div class="withdraw-card" v-for="item in data" :key="item.id">
					<div class="card-header">
						<span class="amount">¥{{ item.money }}</span>
						<!-- <span class="status" :class="getStatusClass(item.status)">{{ item.status_text }}</span> -->
					</div>
					<div class="card-content">
						<div class="info-row">
							<span class="label">提现类型</span>
							<span class="value">{{ item.wallet_text }}</span>
						</div>
						<!-- <div class="info-row">
							<span class="label">姓名</span>
							<span class="value"></span>
						</div> -->
						<div class="info-row">
							<span class="label">时间</span>
							<span class="value">{{ item.time }}</span>
						</div>
						<!---->
					</div>
				</div>
				<!---->
				<div class="van-list__finished-text">没有更多记录</div>
				<!---->
				<div class="van-list__placeholder"></div>
			</div>
			<van-empty v-else description="暂无提现记录" />
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import Fetch from '../../utils/fetch'
	import {
		DropdownMenu,
		DropdownItem
	} from 'vant';

	import {
		Empty
	} from 'vant';

	Vue.use(Empty);
	Vue.use(DropdownMenu).use(DropdownItem);

	export default {
		name: "WithdrawRecord",
		data() {
			return {
				lang: this.$i18n.locale || "zh_cn",
				data: [],
				list: {},
				account: 0,
				option: [],
				listShow: false,
			};
		},
		created() {
			this.$parent.footer('user', false);
		},
		mounted() {
			Fetch('/user/cash_search')
				.then(r => {
					this.showError(r.data.length);
					this.data = r.data;
				})
		},
		methods: {
			showError(len) {
				len == 0 ? this.listShow = true : this.listShow = false
			},
			getStatusClass(status) {
				// 根据状态码判断，更准确
				if (status === 1) { // 成功
					return 'success';
				} else if (status === 2) { // 失败
					return 'failed';
				} else { // 待处理等其他状态
					return 'pending';
				}
			},
		}
	};
</script>

<style lang="less" scoped>
	.withdraw-history-container {
		min-height: 100vh;
		background-color: #f5f7fa;
		padding-bottom: 5.33333vw;
		position: relative;
		font-family: PingFang SC, Helvetica Neue, Helvetica, Arial, sans-serif;

		.background-elements {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			z-index: 0;
			overflow: hidden;

			.wave {
				position: absolute;
				width: 100%;
				height: 53.33333vw;
				background-repeat: no-repeat;
				background-size: cover;

				&.wave-top {
					top: 0;
					background-image: url(~@/assets/images/wave-top.svg);
				}

				&.wave-bottom {
					bottom: 0;
					background-image: url(~@/assets/images/wave-bottom.svg);
				}
			}

			.circle {
				position: absolute;
				border-radius: 50%;
				opacity: .06;

				&.circle-1 {
					width: 66.66667vw;
					height: 66.66667vw;
					background: linear-gradient(135deg, #ffd54f, #ffb300);
					top: 20%;
					left: -21.33333vw;
				}

				&.circle-2 {
					width: 80vw;
					height: 80vw;
					background: linear-gradient(135deg, #ffd54f, #ffb300);
					bottom: 20%;
					right: -26.66667vw;
				}

				&.circle-3 {
					width: 48vw;
					height: 48vw;
					background: linear-gradient(135deg, #ff5252, #c41e17);
					top: 60%;
					left: 10%;
				}
			}
		}

		.header-title {
			position: relative;
			z-index: 1;
			width: 100%;
			text-align: center;
			font-size: 4.8vw;
			font-weight: 600;
			padding: 4vw 0;
			background: #fff;
			box-shadow: 0 1.06667vw 3.2vw rgba(0, 0, 0, .05);
			color: #333;
			border-bottom: 1px solid rgba(0, 0, 0, .05);

			.back-icon {
				position: absolute;
				left: 4vw;
				top: 50%;
				transform: translateY(-50%);
				font-size: 5.33333vw;
				color: #333;
			}
		}

		.content-wrapper {
			position: relative;
			z-index: 1;
			padding: 4vw;
			margin-top: 1.33333vw;

			.withdraw-card {
				background: #fff;
				border-radius: 4.26667vw;
				box-shadow: 0 1.06667vw 3.2vw rgba(0, 0, 0, .05);
				margin-bottom: 4.26667vw;
				overflow: hidden;
				position: relative;
				transition: all .3s ease;

				.card-header {
					padding: 4.26667vw;
					display: flex;
					justify-content: space-between;
					align-items: center;
					background: linear-gradient(90deg, rgba(255, 248, 225, .3), #fff);
					border-bottom: 1px solid rgba(0, 0, 0, .05);

					.amount {
						font-size: 5.33333vw;
						font-weight: 600;
						color: #ff9800;
					}

					.status {
						padding: 1.06667vw 3.2vw;
						border-radius: 3.2vw;
						font-size: 3.46667vw;
						font-weight: 500;

						&.pending {
							background: rgba(255, 152, 0, .1);
							color: #ff9800;
						}

						&.success {
							background: rgba(76, 175, 80, .1);
							color: #4caf50;
						}

						&.failed {
							background: rgba(244, 67, 54, .1);
							color: #f44336;
						}
					}
				}

				.card-content {
					padding: 3.2vw 4.26667vw;

					.info-row {
						display: flex;
						justify-content: space-between;
						padding: 2.13333vw 0;
						border-bottom: 1px dashed rgba(0, 0, 0, .05);

						.label {
							color: #666;
							font-size: 3.73333vw;
						}

						.value {
							color: #333;
							font-size: 3.73333vw;
							font-weight: 500;
							text-align: right;
						}
					}
				}
			}
		}
	}
</style>